import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";

import Profile from "./Profile";
import EditProfile from "./EditProfile";
import { getCompanyInfo } from "store/company";
import { getVerificationStatus } from "store/verification";
import { PROFILE_RELATIVE_ROUTES, PROFILE } from "helpers/routes";

export default function CompanyProfile() {
    const dispatch = useDispatch();
    const profileData = useSelector((state) => state.profile.profileData);
    const lang = useSelector((state) => state.settings.lang);

    const loadData = useCallback(() => {
        dispatch(
            getCompanyInfo({
                id: profileData.company_id,
                lang,
            }),
        );
        // Статус проверки компании отдаёт отдельный эндпоинт — публичная карточка компании его не содержит
        dispatch(getVerificationStatus());
    }, [dispatch, profileData.company_id, lang]);

    useEffect(() => {
        if (profileData.id) {
            loadData();
        }
    }, [loadData, profileData.id]);

    return (
        <Routes>
            <Route path="/" element={<Profile />} />
            <Route path={PROFILE_RELATIVE_ROUTES.edit} element={<EditProfile />} />
            <Route path="*" element={<Navigate to={PROFILE.profile} replace />} />
        </Routes>
    );
}
